var Vendd = (function (Vendd) {
	'use strict';

	var getCartModelOptions = {
		// ignoreExternalModules: false do not use it unless your are forcing a value. the default behaviour will be resolved server side from cart widget config attribute ConfigAttributes_CartIgnoreExternalModulesDefault
		// add other options if needed
	};

	Vendd.MessageBus.subscribe(Vendd.SharedLists.Messages.ShareCart, Vendd.SharedLists, function (envelope) {
        function onSuccess(response) {
            if (response.success) {
				Vendd.MessageBus.publishAsync(Vendd.SharedLists, new Vendd.SharedLists.Messages.ShareCartSuccess(response));
	        } else {
				Vendd.MessageBus.publishAsync(Vendd.SharedLists, new Vendd.SharedLists.Messages.ShareCartFailure(response));
	        }
	    }

	    function onFailure(response) {
			Vendd.MessageBus.publishAsync(Vendd.SharedLists, new Vendd.SharedLists.Messages.ShareCartFailure(response));
	    }

	    var options = {
			url: 'EcomService.svc/ShareCart',
	        data: { title: envelope.message.data.title },
	        onSuccess: onSuccess,
	        onFailure: onFailure
	    };

	    Vendd.Service.call(options);
	});

	Vendd.MessageBus.subscribe(Vendd.SharedLists.Messages.ShareWishList, Vendd.SharedLists, function (envelope) {
		function onSuccess(response) {
			if (response.success) {
				Vendd.MessageBus.publishAsync(Vendd.SharedLists, new Vendd.SharedLists.Messages.ShareWishListSuccess(response));
			} else {
				Vendd.MessageBus.publishAsync(Vendd.SharedLists, new Vendd.SharedLists.Messages.ShareWishListFailure(response));
			}
		}

		function onFailure(response) {
			Vendd.MessageBus.publishAsync(Vendd.SharedLists, new Vendd.SharedLists.Messages.ShareWishListFailure(response));
		}

		var options = {
			url: 'EcomService.svc/ShareWishList',
			data: { listId: envelope.message.data.listId, title: envelope.message.data.title },
			onSuccess: onSuccess,
			onFailure: onFailure
		};

		Vendd.Service.call(options);
	});

	Vendd.MessageBus.subscribe(Vendd.SharedLists.Messages.SendList, Vendd.SharedLists, function (envelope) {
		function onSuccess(response) {
			if (response.success) {
				Vendd.MessageBus.publishAsync(Vendd.SharedLists, new Vendd.SharedLists.Messages.SendListSuccess(response));
			} else {
				Vendd.MessageBus.publishAsync(Vendd.SharedLists, new Vendd.SharedLists.Messages.SendListFailure(response));
			}
		}

		function onFailure(response) {
			Vendd.MessageBus.publishAsync(Vendd.SharedLists, new Vendd.SharedLists.Messages.SendListFailure(response));
		}

		var options = {
			url: 'EcomService.svc/SendList',
			data: { code: envelope.message.data.code, title: envelope.message.data.title, email: envelope.message.data.email },
			onSuccess: onSuccess,
			onFailure: onFailure
		};

		Vendd.Service.call(options);
	});

	//this should be moved to every place that requires this component's data. e.g. cart widget AND in case your page DOES NOT contain that widget then you have to make sure theres somewhere this call 
	(function () {
		var defaultCallExecuted;
		function defaultCall() {
			if (Vendd.User.SessionState && !defaultCallExecuted) {
				defaultCallExecuted = true;

				if (Vendd.User.SessionState.IsNewSession)
					Vendd.User.ClearClientModel();

				if (venddProjectConfigs.CartModelEnabled && !venddProjectConfigs.SiteIsLocked) {
					Vendd.MessageBus.publishAsync(Vendd.Cart, new Vendd.Cart.Messages.GetModel(getCartModelOptions));
				}
			}
		}
		defaultCall();
		Vendd.MessageBus.subscribe(Vendd.User.Messages.GetSessionStateSuccess, Vendd.Cart, function (envelope) {
			defaultCall();
		});
	})();

	return Vendd;

})(Vendd || {});